export const approxTimeDisplay = (minutesToCompletion: number): string => {
  if (minutesToCompletion < 60) {
    const lowerBound = Math.max(2, minutesToCompletion - 5);
    return `${lowerBound}-${minutesToCompletion}min`;
  }

  if (minutesToCompletion < 24 * 60) {
    const hours = minutesToCompletion / 60;
    const lowerBound = hours - 0.1 * hours;
    return `${lowerBound.toFixed(1)}-${hours.toFixed(1)}hrs`;
  }

  const days = minutesToCompletion / 60 / 24;
  return `Approximately ${days} days`;
};

export const etaFromIso = (estimatedCompletionAt: string): string | null => {
  const delta = new Date(estimatedCompletionAt).getTime() - Date.now();
  if (delta <= 0) return null;
  return approxTimeDisplay(Math.ceil(delta / 60000));
};
